import { IValidationRule } from "@/types"

const assetValidationRules: { [s: string]: IValidationRule } = {
    lmid: {
        required: true
    },
    constructionYear: {
        required: true,
        type: "integer",
        min: 1000,
        max: 9999
    },
    width: {
        type: "decimal",
        min: 0
    },
    height: {
        type: "decimal",
        min: 0
    },
    length: {
        type: "decimal",
        min: 0
    },
    volume: {
        type: "decimal",
        min: 0
    },
    weight: {
        type: "decimal",
        min: 0
    },
    operationHours: {
        type: "integer",
        min: 0,
    },
    isSecondhand: {
        required: true
    },
    origin: {
        required: true,
    },
    condition: {
        required: true,
        type: "integer",
        min: 0,
        max: 100,
    },
    holder: {
        required: true
    },
    coordinates: {
        required: true
    },
    referenceNumberSale: {
        required: true
    },
    referenceValue: {
        type: "decimal"
    },
    referenceValueCorrection: {
        type: "decimal"
    },
    assetCategory: {
        required: true,
    },
}

export default assetValidationRules
